export enum AddToBagErrorMetrics {
  Unknown = "unknown",
  CartMismatch = "cart-mismatch-error",
  MultipleMenuType = "multiple-menu-type-error",
  BagLoad = "bag-load-error",
}
